export const NOTIFICATION_STORE = "NOTIFICATION_STORE";

/********************************  State ********************************/
export const EMAIL_NOTIFICATION = "EMAIL_NOTIFICATION";
export const SMS_NOTIFICATION = "SMS_NOTIFICATION";
export const UNREAD_CONVERSATION = "UNREAD_CONVERSATION";
export const GRAPHQL_DATA = "GRAPHQL_DATA";

/********************************  Getters ********************************/
export const GET_SMS_NOTIFICATION = "GET_SMS_NOTIFICATION";
export const GET_EMAIL_NOTIFICATION = "GET_EMAIL_NOTIFICATION";
export const GET_NOTIFICATION_SUBSCRIPTION = "GET_NOTIFICATION_SUBSCRIPTION";
export const GET_NOTIFICATION__SUBSCRIPTION = "GET_NOTIFICATION__SUBSCRIPTION";
export const GET_UNREAD_CONVERSATION = "GET_UNREAD_CONVERSATION";
export const GET_GRAPHQL_DATA = "GET_GRAPHQL_DATA";

/********************************  Mutations ********************************/
export const SET_EMAIL_NOTIFICATION = "SET_EMAIL_NOTIFICATION";
export const SET_SMS_NOTIFICATION = "SET_SMS_NOTIFICATION";
export const MUTATION_NOTIFICATION_SUBSCRIPTION =
  "MUTATION_NOTIFICATION_SUBSCRIPTION";
export const MUTATION_UNREAD_CONVERSATION = "MUTATION_UNREAD_CONVERSATION";
export const SET_GRAPHQL_DATA = "SET_GRAPHQL_DATA";

/********************************  Actions ********************************/
export const FETCH_NOTIFICATION = "FETCH_NOTIFICATION";
export const FETCH_EMAIL_NOTIFICATION = "FETCH_EMAIL_NOTIFICATION";
export const FETCH_SMS_NOTIFICATION = "FETCH_SMS_NOTIFICATION";
export const SET_NOTIFICATION_SUBSCRIPTION = "SET_NOTIFICATION_SUBSCRIPTION";
export const FETCH_UNREAD_CONVERSATION = "FETCH_UNREAD_CONVERSATION";
export const FETCH_GRAPHQL_DATA = "FETCH_GRAPHQL_DATA";
export const SET_APOLLO_CLIENT = "SET_APOLLO_CLIENT";
